<template>
  <div id="record">
    <!-- <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        登录
      </div>
      <div class="right">
        <van-icon name="manager" size="21" />
      </div>
    </div>-->
    <div class>
      <img src="@/assets/login-top.png" class="top-img" />
  
      <div class="form-div">
            <div class="right" @click="toHome()">
        <van-icon name="wap-home" size="21" color="#037a42"/>
      </div>
        <div class="login-main">
          <div class="login-tit">个人登录</div>
          <div class="form">
            <div style="margin-top: 0.8rem">
              <van-icon size="20" name="user-circle-o" color="grey" />
            </div>
            <div>
              <van-field v-model="number" size="large" clearable placeholder="输入您的残疾证号" />
            </div>
          </div>
        </div>
        <div class="login-btn" v-show="!showL" @click="toLogin()">
          <span>登录</span>
          </div>
            <div class="login-btn" v-show="showL" >
           <van-loading size="24px" color="white"><span style="color:white">登录中...</span></van-loading>
          </div>
      </div>
      <!-- <van-overlay :show="showL">
      <van-loading size="24px">登录中...</van-loading>
      </van-overlay> -->
    </div>
  </div>
</template>
<script>
import { Icon, Field, Toast,Loading ,Overlay} from "vant";
import { login } from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay
  },
  data() {
    return {
      number: "",
      showL:false
    };
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome(){
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
      // this.$router.push('/index');
    },
    toLogin() {
      var parm = {
        disabled_number: this.number,
      };
      if (this.number == "") {
        Toast("请输入残疾证号");
      } else {
        this.showL=true
        login(parm).then((res) => {
          Toast(res.message);
          if (res.status == 1) {
        this.showL=false
            this.$router.go(-1);
            localStorage.setItem("tokenC", res.data.token);
          } else {
        this.showL=false
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.top-img {
  width: 100%;
}
.form-div {
  position: absolute;
  top: 8rem;
  width: 80%;
  /* margin: 0 auto; */
  margin-left: 10%;
}
.login-main {
  padding: 1rem 0 2.5rem;

  background: white;

  /* height: 8rem; */
  -webkit-box-shadow: 0px 0px 5px 0px gainsboro;
  box-shadow: 0px 0px 5px 0px gainsboro;
  border-radius: 5px;
}
.login-tit {
  margin-bottom: 1rem;
  color: #82c361;
}
.form {
  display: flex;
  border-bottom: solid 2px #efefef;
  width: 80%;
  margin: 0 auto;
}
.login-btn {
  background: #9edb62;
  color: white;
  box-shadow: 0px 0px 5px 0px #239a4e;
  height: 2.5rem;
  line-height: 2.5rem;
  font-size: 1.1rem;
  width: 100%;
  margin: 0 auto;
  margin-top: 1.5rem;
}
.right{
  position: absolute;
    right: 0.3rem;
    top: 0.3rem;
}
</style>


// WEBPACK FOOTER //
// src/page/login.vue